var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrintIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5A65F244-6286-46C6-BF9B-485F020E60A7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Guidemark-Admin-Desktop-Availability",
    transform: "translate(-1113.000000, -79.000000)",
    fill: "#5A87EF",
    fillRule: "nonzero",
    stroke: "#5A87EF",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group",
    transform: "translate(1114.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9789474,4.61052632 L12.6315789,4.61052632 L12.6315789,0.821052632 C12.6315789,0.588511684 12.4430673,0.4 12.2105263,0.4 L3.78947368,0.4 C3.55693274,0.4 3.36842105,0.588511684 3.36842105,0.821052632 L3.36842105,4.61052632 L2.02105263,4.61052632 C0.904856085,4.61052632 0,5.5153824 0,6.63157895 L0,11.0105263 C0,12.1267229 0.904856085,13.0315789 2.02105263,13.0315789 L4.21052632,13.0315789 L4.21052632,15.1368421 C4.21052632,15.3693831 4.399038,15.5578947 4.63157895,15.5578947 L11.3684211,15.5578947 C11.600962,15.5578947 11.7894737,15.3693831 11.7894737,15.1368421 L11.7894737,13.0315789 L13.9789474,13.0315789 C15.0951439,13.0315789 16,12.1267229 16,11.0105263 L16,6.63157895 C16,5.5153824 15.0951439,4.61052632 13.9789474,4.61052632 Z M4.21052632,1.24210526 L11.7894737,1.24210526 L11.7894737,4.61052632 L4.21052632,4.61052632 L4.21052632,1.24210526 Z M10.9473684,14.7157895 L5.05263158,14.7157895 L5.05263158,10.5052632 L10.9473684,10.5052632 L10.9473684,14.7157895 Z M15.1578947,11.0105263 C15.1578947,11.661641 14.630062,12.1894737 13.9789474,12.1894737 L11.7894737,12.1894737 L11.7894737,10.0842105 C11.7894737,9.85166958 11.600962,9.66315789 11.3684211,9.66315789 L4.63157895,9.66315789 C4.399038,9.66315789 4.21052632,9.85166958 4.21052632,10.0842105 L4.21052632,12.1894737 L2.02105263,12.1894737 C1.36993798,12.1894737 0.842105263,11.661641 0.842105263,11.0105263 L0.842105263,6.63157895 C0.842105263,5.98046429 1.36993798,5.45263158 2.02105263,5.45263158 L13.9789474,5.45263158 C14.630062,5.45263158 15.1578947,5.98046429 15.1578947,6.63157895 L15.1578947,11.0105263 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print-icon.d910c8a750e827f058851f5542ba0b7c.svg";
export { ForwardRef as ReactComponent };